import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import { type Tag, TagEntityType } from 'tm3-core/api.dtos';

class TagsStore extends CacheStore<Tag> {
  constructor() {
    super('tags');
  }
  @computed
  get Current() {
    return this.All.filter((x) => x.isActive);
  }

  @computed
  get CurrentStockTags() {
    return this.Current.filter(
      (t) => t.type === TagEntityType.General || t.type === TagEntityType.Stock
    );
  }

  @computed
  get CurrentClientTags() {
    return this.Current.filter(
      (t) => t.type === TagEntityType.General || t.type === TagEntityType.Patient
    );
  }

  @computed
  get CurrentClientTagsForDropdown() {
    return this.CurrentClientTags.map((t) => {
      return {
        text: t.name,
        payload: t.name
      };
    });
  }

  @computed
  get CurrentStockTagsForDropdown() {
    return this.CurrentStockTags.map((t) => {
      return {
        text: t.name,
        payload: t.name
      };
    });
  }
}
export default TagsStore;
